import React from "react";
import { useNavigate } from "react-router-dom";
import "./Services.css";

/* NOTE: `docs` here mirror the actual required uploads enforced by the
   apply form (ApplyService.jsx → getRequiredFiles), so the card and the
   form stay in sync. Update both together if requirements change. */
const SERVICES = [
  { title: "जन्म प्रमाणपत्र", description: "नवजात बालकाच्या जन्माची अधिकृत नोंद व प्रमाणपत्र मिळवा.", icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z", tint: "#E8F3EA", ink: "#0F5C2E", docs: ["रुग्णालयाची पावती", "पालकांचे आधार कार्ड", "पत्ता पुरावा"] },
  { title: "मृत्यू प्रमाणपत्र", description: "अधिकृत नोंदींसाठी मृत्यू प्रमाणपत्रासाठी अर्ज करा.", icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z", tint: "#E7F0F8", ink: "#1466A8", docs: ["रुग्णालयाची पावती", "मृत व्यक्तीचे आधार कार्ड", "अर्जदाराचे आधार कार्ड"] },
  { title: "उत्पन्न प्रमाणपत्र", description: "शासकीय योजना व शिक्षणासाठी उत्पन्नाचा पुरावा.", icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z", tint: "#FBF0E0", ink: "#C06A12", docs: ["अर्जदाराचे आधार कार्ड", "रेशन कार्ड", "उत्पन्नाचा पुरावा"] },
  { title: "रहिवासी प्रमाणपत्र", description: "शासकीय सेवांसाठी रहिवासाचा अधिकृत पुरावा.", icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6", tint: "#E8F3EA", ink: "#0F5C2E", docs: ["अर्जदाराचे आधार कार्ड", "वीज बिल", "रेशन कार्ड"] },
  { title: "विवाह प्रमाणपत्र", description: "कायदेशीर विवाह नोंदणी व प्रमाणपत्रासाठी अर्ज करा.", icon: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z", tint: "#F8E9EC", ink: "#B23A55", docs: ["वराचे आधार कार्ड", "वधूचे आधार कार्ड", "वयाचा पुरावा", "विवाह छायाचित्र", "साक्षीदारांचे आधार"] },
];

const Services = () => {
  const navigate = useNavigate();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="rk-hero">
        <div className="rk-hero-inner">
          <div className="rk-crumb">मुख्यपृष्ठ / सेवा</div>
          <h1 className="rk-hero-title">ग्रामपंचायत सेवा</h1>
          <p className="rk-hero-sub">विविध प्रमाणपत्रे व सेवांसाठी घरबसल्या ऑनलाइन अर्ज करा. आवश्यक कागदपत्रे तयार ठेवा.</p>
        </div>
      </section>

      <section className="rk-wrap">
        <div className="rk-cols rk-cols-3">
          {SERVICES.map((s) => (
            <div key={s.title} className="rk-card rk-svc">
              <div style={{ width: 56, height: 56, borderRadius: 14, background: s.tint, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={s.ink} strokeWidth="1.9"><path strokeLinecap="round" strokeLinejoin="round" d={s.icon} /></svg>
              </div>
              <h3 style={{ fontWeight: 700, fontSize: 20, marginTop: 18, color: "#17241C" }}>{s.title}</h3>
              <p style={{ color: "#5B6B60", fontSize: 14.5, lineHeight: 1.6, marginTop: 8 }}>{s.description}</p>

              <div className="rk-svc-docs">
                <div className="rk-svc-docs-title">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0F5C2E" strokeWidth="1.9"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                  आवश्यक कागदपत्रे
                </div>
                <ul className="rk-svc-docs-list">
                  {s.docs.map((d) => (
                    <li key={d}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#0F5C2E" strokeWidth="2.4"><path strokeLinecap="round" strokeLinejoin="round" d="M20 6 9 17l-5-5" /></svg>
                      {d}
                    </li>
                  ))}
                </ul>
              </div>

              <button className="rk-primary-btn" style={{ marginTop: 18, width: "100%" }} onClick={() => navigate(`/apply-service?service=${encodeURIComponent(s.title)}`)}>अर्ज करा</button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Services;
